<template>
  <div>
    <modal name="edit-task" height="auto" @closed="values = []">
      <div class="task-modal-head">
        <div class="task-modal-close">
          <a @click="$modal.hide('edit-task')"> &times; </a>
        </div>
        <div class="px-4 pt-3 px-md-4 modal-head-description d-flex">
          <div class="write-input">
            <input
              class="write-title"
              type="text"
              v-model="title"
              :placeholder="
                task.bulk
                  ? $t('task.create.bulkTitle')
                  : $t('task.create.title')
              "
            />
          </div>
        </div>
        <div class="px-4 px-md-4 modal-description-btn">
          <button
            class="mx-1 mx-md-1 btn-label"
            v-for="(user, index) in task.users"
            :key="index"
          >
            <span class="close-icon-btn" @click="removeEmp(user)"> × </span>
            {{ user.firstName }} {{ user.lastName }}
          </button>
          <span class="multi-select"></span>
          <errors :errors="errors" field="users" />
        </div>
        <div class="title-calender-w ml-4 mt-2 d-flex common-filter">
          <div class="p-2 icon">
            <i class="far fa-calendar"></i>
          </div>
          <div>
            <d-datepicker
              v-model="task.dueDate"
              :placeholder="$t('task.create.dueDate')"
              :language="fr"
              small
              typeable
            />
          </div>
        </div>
        <div class="commient-bg-color">
          <div class="mt-md-1 uplord-and-submit-btn ml-4">
            <div class="drop-zone">
              <dropzone
                @fileAdded="fileAdded"
                :remove="removeFlag"
                :preview="previewImages"
                @removeFlag="removeFlag = flag"
                @previewFlag="previewImages = []"
                @removeFileFromTask="removeFileFromTask"
              />
            </div>
            <div class="modal-3-text mt-3">
              <textarea
                :placeholder="$t('task.create.description')"
                v-model="task.description"
              >
              </textarea>
              <errors :errors="errors" field="description" />
            </div>
            <div class="mt-md-4 modal-3-save mb-md-2">
              <button class="modal-save-btn" @click="updateTask()">
                {{ $t("task.update") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import SelectPure from 'select-pure';
import TimeUtils from '../../utils/TimeUtils';
import Errors from '../../components/error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import TaskHelper from '../../helper/TaskHelper';
import Dropzone from '../task/Dropzone';
import { fr } from 'vuejs-datepicker/dist/locale';

export default {
  components: {
    Errors,
    Dropzone,
  },

  mounted() {
    this.$root.$on('editTask', (task) => {
      this.task = task;
      setTimeout(() => {
        this.editTask();
      }, 100);
      setTimeout(() => {
        this.populateSelect();
      }, 100);
      this.viewFile(task.fileName);
    });
  },

  data() {
    return {
      task: {},
      select: {},
      editFlag: false,
      values: [],
      errors: {},
      requiredFields: ['title'],
      files: [],
      removedFiles: [],
      removeFlag: false,
      previewImages: [],
      fr,
    };
  },

  computed: {
    employeeList() {
      return this.$store.state.task.employeeList;
    },

    title: {
      get() {
        return this.task.title;
      },

      set(val) {
        this.task.title = TaskHelper.capitalizeTitle(val);
      },
    },

    personalRoute() {
      return this.$route.path == '/personalTasks';
    },

    whichPlaceholder() {
      return this.personalRoute
        ? this.$t('task.create.addCollaborator')
        : this.$t('task.create.addEmployee');
    },
  },

  methods: {
    viewFile(name) {
      const body = {
        name,
      };
      this.$services.task.readFile(body).then((res) => {
        if (res.status === 200) {
          this.previewImages = res.data.image;
        }
      });
      this.removedFiles = [];
    },

    fileAdded(files) {
      this.files = files;
      this.files.forEach((file, index) => {
        if (!file.upload) {
          this.files.splice(index, 1);
        }
      });
    },

    removeFileFromTask(name) {
      this.task.fileName.includes(name) ? this.removedFiles.push(name) : '';
    },

    uploadFile(data) {
      this.$services.task.uploadFile(data).then((res) => {
        if (res.status == 200) {
          this.removeFlag = true;
        }
      });
    },

    populateSelect() {
      TaskHelper.deleteSelectPureIfAny();
      this.select = new SelectPure('.multi-select', {
        options: this.employeeList,
        value: this.editFlag && this.values,
        multiple: true,
        placeholder: this.whichPlaceholder,
        autocomplete: true,
        icon: 'fa fa-times',
        inlineIcon: false,
        onChange: (value) => {
          this.user(value);
        },
        classNames: {
          select: 'select-pure__select',
          dropdownShown: 'select-pure__select--opened',
          multiselect: 'select-pure__select--multiple',
          label: 'select-pure__label',
          placeholder: 'select-pure__placeholder',
          dropdown: 'select-pure__options',
          option: 'select-pure__option',
          autocompleteInput: 'select-pure__autocomplete',
          selectedLabel: 'select-pure__selected-label',
          selectedOption: 'select-pure__option--selected',
          placeholderHidden: 'select-pure__placeholder--hidden',
          optionHidden: 'select-pure__option--hidden',
        },
      });
    },

    user(val) {
      const users = [];
      this.task.users = [];
      this.employeeList.forEach((user) => {
        if (val.includes(user.value)) {
          users.push({
            reference: user.reference,
            firstName: user.firstName,
            lastName: user.lastName,
            groupReference: user.groupReference,
            status: this.task.bulk && 'pending',
          });
        }
      });
      this.task.users = users;
    },

    editTask() {
      this.editFlag = true;
      this.task.users.forEach((u) => {
        this.employeeList.forEach((user) => {
          if (user.reference == u.reference) {
            this.values.push(user.value);
          }
        });
      });
    },

    validateTask() {
      this.errors = {};
      return ErrorsHelper.checkErrors(
        this.requiredFields,
        this.task,
        this.errors,
      );
    },

    async updateTask() {
      if (this.validateTask()) {
        if (this.task.fileName.length && this.removedFiles.length) {
          const files = this.task.fileName.filter(name => !this.removedFiles.includes(name));
          this.task.fileName = files;
          await this.$services.task
            .deleteFile(this.removedFiles)
            .then((res) => {
              if (res.status == 200) {
                this.removedFiles = [];
              }
            });
        }
        if (this.files.length) {
          const form = new FormData();
          const time = new Date().valueOf().toString();
          const unique = time.slice(time.length / 2, time.length - 1);
          this.files.forEach((file) => {
            form.append('file', file, unique.concat(file.name));
            this.task.fileName.push(unique.concat(file.name));
          });
          await this.uploadFile(form);
        }
        if (this.task.dueDate != null) {
          if (this.task.dueDate.toString().length > 10) {
            this.task.dueDate = TimeUtils.formatDateString(this.task.dueDate);
          }
        }
        const status = TaskHelper.updateTask(this.task);
        this.task.edit = true;
        this.pushInArray();
        status
          ? this.$miniToastr.success('Tâche mise à jour')
          : this.$miniToastr.success('Tâche non mise à jour');
        this.$modal.hide('edit-task');
        const desc = `${this.task.createdBy.firstName} ${this.task.createdBy.lastName} a mis à jour la tâche`;
        this.sendNotification(desc);
      }
    },

    async sendNotification(description) {
      const users = this.task.users;
      const status = await TaskHelper.sendNotification(
        this.task,
        users,
        description,
      );
      status == 200
        ? this.$miniToastr.success('Notification envoyé.')
        : this.$miniToastr.error('Notification pas envoyé. erreur #9167');
    },

    pushInArray() {
      const obj = {
        task: this.task,
        comments: [],
      };
      this.$emit('pushInTasksArray', obj);
    },

    removeEmp(user) {
      const users = this.task.users.filter(u => u.reference != user.reference);
      this.task.users = users;
      let value = '';
      this.employeeList.forEach((u) => {
        if (u.reference == user.reference) {
          value = u.value;
        }
      });
      const index = this.select._config.value.indexOf(value);
      this.select._config.value.splice(index, 1);
      TaskHelper.removeClassFromDiv(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-zone {
  width: 92%;
}
.modal-description-btn {
  display: flex;
  flex-wrap: wrap;
  .btn-label {
    background-color: #e8e9f0;
    display: inline-block;
    padding: 4px 40px 4px 20px;
    border: 0;
    border-radius: 3px;
    font-family: "SF-Pro-Text";
    color: #303778;
    font-weight: 500;
    font-size: 14px;
    outline: none;
    height: 35px;
    margin-bottom: 10px;
    position: relative;
    @media (min-width: 320px) and (max-width: 600px) {
      font-size: 12px;
    }
    .close-icon-btn {
      position: absolute;
      right: 12px;
      top: 0;
      width: 15px;
      line-height: 35px;
      text-align: center;
      font-size: 15px;
      font-weight: 700;
      border-left: 1px solid #d8cfcf;
      border-radius: 0;
      height: 35px;
      padding-left: 8px;
      color: #9e8d8d;
    }
  }
}
.task-modal-head {
  position: relative;
  min-height: 550px;
  height: 550px;
  overflow-y: auto;
  .task-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
  .modal-head-description {
    .description-unorder {
      margin: 0;
      padding: 0;
    }
    li {
      display: inline-block;
      margin-right: 5px;
      ul {
        padding-left: 25px;
        li {
          padding: 0px;
          margin: 0px;
        }
      }
      h3 {
        font-size: 26px;
        font-family: "SF-Pro-Text";
        color: #212529;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 17px;
        }
      }
      span {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }

  .modal-description-pera {
    background-color: #f6f8ff;
    padding: 20px 0;
    p {
      font-size: 16px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 14px;
      }
    }
  }
  .modal-comment-section {
    box-shadow: 0 0 2px 0 #b9bbd1;
    margin-bottom: 7px;
    padding: 18px 0;
    .modal-comment-profile {
      background-color: #b9bbd1;
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      border-radius: 60px;
      margin-top: -1px;
      margin-bottom: 12px;
      @media (min-width: 320px) and (max-width: 600px) {
        height: 40px;
        width: 40px;
        border-radius: 40px;
        margin: 10px 10px 0 0;
      }
      p {
        margin: 0;
        font-size: 20px;
        color: #fff;
        font-family: "SF-Pro-Text";
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 15px;
        }
      }
    }
    .modal-comment-text {
      width: 85%;
      margin-left: 20px;
      @media (min-width: 320px) and (max-width: 600px) {
        margin-left: 5px;
      }
      h3 {
        margin: 0;
        font-size: 20px;
        font-family: "SF-Pro-Text";
        color: #303778;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 16px;
        }
      }
      p {
        text-align: justify;
        line-height: normal;
        color: #212529;
        font-family: "SF-Pro-Text";
        margin: 0;
        @media (min-width: 320px) and (max-width: 600px) {
          font-size: 12px;
        }
      }
      textarea {
        width: 100%;
        height: 100px;
        border-radius: 4px;
        border: solid 1px #becad6;
        resize: none;
        outline: none;
        padding: 10px;
        @media (min-width: 320px) and (max-width: 600px) {
          margin-bottom: 20px;
        }
      }
    }
    .comment-submit-btn {
      background-color: #4f78e1;
      height: 35px;
      color: #fff;
      margin-top: 10px;
      font-family: "SF-Pro-Text";
      outline: none;
      padding: 4px 15px;
      border: none;
      margin-left: 10px;
      border-radius: 3px;
    }
  }
}
.modal-3-save {
  text-align: center;
  .modal-save-btn {
    background-color: #4f78e2;
    padding: 7px 30px;
    display: inline-block;
    border: none;
    color: #fff;
    border-radius: 4px;
    font-family: "SF-Pro-Text";
    outline: none !important;
    @media (min-width: 320px) and (max-width: 600px) {
      margin-top: 20px;
    }
  }
}
</style>
